const EnvManager = Object.freeze({
  BACKEND_URL: process.env.REACT_APP_AUTH_SERVICE_BACKEND_URL,
});

export default EnvManager;
